import React from "react";
import { Link } from "react-router-dom";
import "./SolutionsSection.css";

const SolutionsSection = () => {
  return (
    <section className="solutions-section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">
            Pourquoi Choisir Monagora ?
          </h2>
          <p className="section-subtitle">
            Découvrez les 3 raisons qui font de Monagora votre partenaire idéal
          </p>
        </div>
        
        <div className="solutions-grid">
          <div className="solution-card">
            <div className="solution-header">
              <h3>⏰ Récupérez Votre Temps</h3>
            </div>
            <div className="solution-content">
              <p>
                L'automatisation complète vous fait gagner 3 heures par jour. 
                Pendant que l'IA gère votre planning, vous vous concentrez sur ce qui compte vraiment.
              </p>
              <ul className="solution-features">
                <li>✓ 3h économisées par jour</li>
                <li>✓ Zéro temps de traitement</li>
                <li>✓ Planning optimisé 24h/24</li>
                <li>✓ Réactivité instantanée</li>
              </ul>
              <Link to="/automatique" className="solution-link">
                Découvrir les gains de temps →
              </Link>
            </div>
          </div>
          
          <div className="solution-card">
            <div className="solution-header">
              <h3>🤖 IA vs Employé Humain</h3>
            </div>
            <div className="solution-content">
              <p>
                Notre intelligence artificielle surpasse un employé humain sur tous les points : 
                disponibilité, précision, coût et fiabilité.
              </p>
              <ul className="solution-features">
                <li>✓ Disponibilité 24h/24</li>
                <li>✓ 100% de précision</li>
                <li>✓ Zéro coût caché</li>
                <li>✓ Jamais malade</li>
              </ul>
              <Link to="/ia-vs-humain" className="solution-link">
                Comparaison détaillée →
              </Link>
            </div>
          </div>
          
          <div className="solution-card">
            <div className="solution-header">
              <h3>💰 Gains Financiers Garantis</h3>
            </div>
            <div className="solution-content">
              <p>
                Découvrez comment notre solution vous permet de réaliser des économies 
                significatives et d'améliorer votre rentabilité.
              </p>
              <ul className="solution-features">
                <li>✓ Économies importantes sur les coûts</li>
                <li>✓ ROI rapide grâce aux économies</li>
                <li>✓ Croissance sans limite</li>
              </ul>
              <Link to="/gains-financiers" className="solution-link">
                Calculer vos économies →
              </Link>
            </div>
          </div>
        </div>
        
        <div className="solutions-cta">
          <Link to="/automatique" className="btn btn-primary">
            Commencer Maintenant
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection; 